/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AppContainer from "../../../Components/Structure/AppContainer";
import TableHeader from "../../../Components/Common/TableHeader";
import Loader from "../../../Components/Common/Loader";
import Pagination from "../../../Components/Common/Pagination";
import ajaxParent from "../../../util/remote/ajaxParent";
import SearchForm from "../../../Components/Common/SearchForm";
import ajaxBank from "../../../util/remote/ajaxBank";
import * as XLSX from "xlsx";


function ParentCreditBalancesPage() {
    const [query, setQuery] = useState("");
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [overallCreditBalance, setOverallCreditBalance] = useState(false);
    const [first, setFirst] = useState("");

    const [meta, setMeta] = useState([]);
    const [creditBalances, setCreditBalances] = useState([]);
    const [printableCreditBalances, setPrintableCreditBalances] = useState([]);


  useEffect(() => {
      if (query) {
          searchCreditBalances();
      } else {
          getCreditBalances(page);
      }
  }, [page]);

  useEffect(() => {
          getOverallCreditBalance();
          printCreditBalances();
  }, []);

  const getOverallCreditBalance = async () => {
        const server_response = await ajaxBank.fetchParentCreditBalance();
        if (server_response.status === "OK") {
          setOverallCreditBalance(server_response.details);
        } else {
          setOverallCreditBalance("404");
        }
    };
  
  const getCreditBalances = async (currentPage) => {
    setLoading(true);
    const server_response = await ajaxParent.listAllParentCreditBalances(currentPage);
    setLoading(false);

    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setCreditBalances(server_response.details.data || []);
    } else {
        setCreditBalances([]);
    }
};

const printCreditBalances = async () => {
  setLoading(true);
  const server_response = await ajaxParent.printAllParentCreditBalances();
  setLoading(false);
  if (server_response.status === "OK") {
      setPrintableCreditBalances(server_response.details);
  } else {
      setPrintableCreditBalances([]);
  }
};

const searchCreditBalances = async (e) => {
    if (e) {
        e.preventDefault();
    }
    setLoading2(true);
    const server_response = await ajaxParent.searchAllParentCreditBalances(page, query);
    setLoading2(false);
    if (server_response.status === "OK") {
      setFirst(server_response.details.meta.offset);
        setMeta(server_response.details.meta.totalPages);
        setCreditBalances(server_response.details.data || []);
    } else {
        setCreditBalances([]);
    }
};

  const handlePagination = (newPage) => {
    if (newPage > 0 && newPage <= meta) {
      setPage(newPage);
    }
  };

  const setBalances = (e) => {
    e.preventDefault();
    setQuery("");
    setPage(1);
    getCreditBalances(1);
    
  };

  const exportToPDF = () => {
      const pdf = new jsPDF("p", "pt", "a4");
      const columns = ["Parent Name", "Username", "Buzztime Credit"];
      const data = printableCreditBalances.map(item => [
        item.user,
        item.username,
        item.balance.total_c
      ]);
  
      pdf.autoTable({ head: [columns], body: data });
      pdf.save("parent_credit_balances_list.pdf");
  };

  const exportToExcel = () => {
        const worksheetData = printableCreditBalances.map((item) => ({
          "Parent Name": item.user,
          "Username": item.username,
          "Buzztime Credit": item.balance.total_c,
        }));
      
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Credit Balances");
      
        XLSX.writeFile(workbook, "credit_balances_list.xlsx");
  };


  return (
    <AppContainer title="Parent Credit Balances">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="row">
            <div class="col-lg-12">
                <div class="card custom-card" style={{ paddingBottom: "10px" }}>
                    <div className="card-body map-card gradient-my-blue">
                        <div class="item-title mb-2" style={{ color: "white" }}>
                            <b>OVERALL</b>
                        </div>
                        <div class="row">
                        
                            <div class="col-xl-12 col-lg-12 col-sm-6 pr-0 pl-0">
                                <div class="text-center">
                                    <h2 class="mb-1 number-font" style={{ color: "white" }}>
                                        <span class="counter">
                                            {overallCreditBalance? overallCreditBalance:"..."}
                                        </span>
                                    </h2>
                                    <p class="mb-0 text-light"> Parent Credit Balance</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>

        <div className="row">
            <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                <div className="row">
                <div className="col-lg-12 col-md-12 mt-3">
              <div className="card height-auto">
                <div className="card-body">
                <div class="heading-layout1 mg-b-5">
        <TableHeader
          title = "Parent Credit Balances List"
          subtitle="List of all the parents and guardians with their credit balances sorted from highest to lowest"    
        />
        <div class="dropdown">
            
          {/* <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false">...</a> */}
          <Link class="" onClick={setBalances} role="button"><i class="fas fa-redo-alt ml-3"></i></Link>
          <Link class="" onClick={exportToPDF} role="button"><i class="fas fa-download ml-3"></i></Link>
          <Link class="" onClick={exportToExcel} role="button"><i class="fas fa-file-excel ml-3"></i></Link>

        </div>
      </div>

      <SearchForm searchTerm={query} setSearchTerm={setQuery} placeholder="Enter names or username of user..."
      searchItems={searchCreditBalances} setPage={setPage} setItems={setBalances}/>

      <div className="border-top mt-3"></div>
      <div className="table-responsive">
      {loading || loading2 ? (
        <Loader />
                      ) : (
        <table className="table display data-table text-nowrap">
            <thead>
                <tr>
                <th scope="col">No.</th>
                <th scope="col">Names</th>
                <th scope="col">Username</th>
                <th scope="col"> Buzztime Credit</th>
                
                </tr>
            </thead>
            <tbody>
                {creditBalances.length > 0 ? (
                    creditBalances.map((item, index) => (
                    <tr key={index}>
                        

                        <td>{index + first + 1} </td>
                        
                        <td><OverlayTrigger placement="top" overlay={
                                                                <Tooltip id="refresh-tooltip">
                                                                    View Statement
                                                                </Tooltip>}><Link to={`/credit-balances/statement/${item.user_id}?username=${encodeURIComponent(item.username)}&user=${encodeURIComponent(item.user)}&balance=${encodeURIComponent(item.balance.total_c)}`}>{item.user}
                                                                </Link></OverlayTrigger></td>
                        <td>{item.username}</td>
                        <td>{item.balance.total_c}</td>

                    </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="4" style={{ textAlign: "center" }}>
                            No users registered yet.
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
      )}
        
      </div>
      <Pagination currentPage={page} totalPages={meta} onPageChange={handlePagination}/>
                </div>
              </div>
          </div>
                
                
                </div>
            </div>
        </div>
        

        
      
    </AppContainer>
  );
}

export default ParentCreditBalancesPage;
